export default {
    root: {
        minWidth: '720px',
    }
  };